import { Box, Button, TextField, Typography, IconButton, InputAdornment, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "../subComponent/HeaderComponent";
import { useState, useEffect } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import authService from "../services/authService";

const CreatorLogin = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        username: "",
        password: ""
    });
    const [showPassword, setShowPassword] = useState(false);
    const [loginError, setLoginError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Check if user is already logged in
        if (authService.isAuthenticated()) {
            navigate("/creator-portal");
        }
    }, [navigate]);

    const handleChange = (field) => (event) => {
        setLoginError("");
        setFormData(prev => ({
            ...prev,
            [field]: event.target.value
        }));
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const onSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setLoginError("");

        try {
            const response = await authService.login(formData);
            if (response.success) {
                navigate("/creator-portal");
            } else {
                setLoginError(response.message || "Login failed");
            }
        } catch (error) {
            setLoginError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box sx={{ height: "100vh", backgroundColor: "#020817" }}>
            <HeaderComponent />
            <Box sx={{
                p: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "calc(100vh - 64px)" // Adjust based on your header height
            }}>
                <Box sx={{
                    p: 3,
                    width: "320px",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                    backgroundColor: "white",
                    borderRadius: "10px"
                }}>
                    <Typography variant="h5" sx={{ mb: 2, textAlign: "center", fontWeight: "500" }}>
                       Admin Login
                    </Typography>
                    <form onSubmit={onSubmit}>
                        <TextField
                            placeholder="Username"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.username}
                            onChange={handleChange('username')}
                            required
                            disabled={isLoading}
                            autoComplete="username"
                        />
                        <TextField
                            placeholder="Password"
                            variant="outlined"
                            type={showPassword ? "text" : "password"}
                            fullWidth
                            margin="normal"
                            value={formData.password}
                            onChange={handleChange('password')}
                            required
                            disabled={isLoading}
                            autoComplete="current-password"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={togglePasswordVisibility}
                                            edge="end"
                                            disabled={isLoading}
                                        >
                                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        {loginError && (
                            <Typography color="error" sx={{ fontSize: "0.875rem", mt: 1 }}>
                                {loginError}
                            </Typography>
                        )}

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={isLoading}
                            sx={{
                                mt: 2,
                                fontWeight: "bold",
                                height: 42
                            }}
                        >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Log In"}
                        </Button>
                    </form>
                </Box>
            </Box>
        </Box>
    );
};

export default CreatorLogin;